import crudActions from '../../crud/actions'

const actions = crudActions('CAREASSESSMENT_DOMESTICSUPPORTACTIVITIES_')

export default actions
